import { render, staticRenderFns } from "./CustomerSingleDocument.vue?vue&type=template&id=e35e81a8"
import script from "./CustomerSingleDocument.vue?vue&type=script&lang=js"
export * from "./CustomerSingleDocument.vue?vue&type=script&lang=js"
import style0 from "./CustomerSingleDocument.vue?vue&type=style&index=0&id=e35e81a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports